import React from "react";
import { Button, Drawer } from "antd";

import QuickbooksUserSearch from '../../quickbooks-user-search'

class ChangeAssignQuickbooksSeller extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            assignQuickbooksSellerDrawerVisible: false
        };
    }

    render() {

        const { assigned, supplierId } = this.props;

        return (
            <div>
                <Drawer
                    title="Assign Quickbooks Seller"
                    placement="right"
                    visible={this.state.assignQuickbooksSellerDrawerVisible}
                    closable={true}
                    onClose={() => this.setState({ assignQuickbooksSellerDrawerVisible: false })}
                >
                    {this.state.assignQuickbooksSellerDrawerVisible ?
                        <div>
                            <QuickbooksUserSearch

                                onClickDone={ this.props.updateSupplierDetails }
                                orderId={ this.props.cart._id }
                                supplierDetails={ this.props.supplierDetails }

                            />
                            
                        </div>
                        :
                        null
                    }

                </Drawer>
                <Button
                    type={assigned ? "danger" : "default"}
                    disabled={supplierId === "noSupplier"}
                    onClick={this.onClickChangeQuickbooksSeller}>
                    {`${assigned ? "Change " : "Assign "} Quickbooks Seller`}
                </Button>
            </div>
        );

    }

    onClickChangeQuickbooksSeller = () => {

        this.setState({
            assignQuickbooksSellerDrawerVisible: true
        })

    }

}

export default ChangeAssignQuickbooksSeller;


// WEBPACK FOOTER //
// ./src/components/orders-v3/modal/supplier-management-panel/change-assign-quickbooks-seller-button.js